import { Button } from '@/shared/ui/Button';
import { IconEye, IconEyeOff } from '@/shared/ui/Icon';
import { useOcultarValores } from '@/shared/state/OcultarValoresContext';

/**
 * Botão de alternar a privacidade de valores monetários. Renderiza no
 * `acoes` do PageHeader das telas que mostram dinheiro (orçamento,
 * financeiro, relatórios). Quando ligado, os valores aparecem como
 * `R$ ●●●●` na tela inteira.
 */
export function BotaoOcultarValores() {
  const { ocultar, alternar } = useOcultarValores();
  return (
    <Button
      onClick={alternar}
      title={ocultar ? 'Mostrar valores' : 'Ocultar valores'}
      aria-label={ocultar ? 'Mostrar valores' : 'Ocultar valores'}
      aria-pressed={ocultar}
    >
      {ocultar ? <IconEyeOff className="btn__icon" /> : <IconEye className="btn__icon" />}
      {ocultar ? 'Mostrar valores' : 'Ocultar valores'}
    </Button>
  );
}
